import { expLogJSON } from '@/common/utils/log-utils/report';

export function log(val) {
  window.log('yx_center', 'workbench_activitytheme', JSON.stringify({ activitytheme: val }));
}

export function detailLog(theme, val, id) {
  window.log('yx_center', 'workbench', JSON.stringify({ activitytheme: theme, activityid: id, signuporreview: val }));
}

// 曝光埋点
export function exposureLog(theme, id) {
  expLogJSON('yx_center', 'workbench_listinfo', JSON.stringify({ activitytheme: theme, activityid: id }));
}
